(function ($) {
    "use strict";

    /*[ Load page ]
    ===========================================================*/
    $(".animsition").animsition({
        inClass: 'fade-in',
        outClass: 'fade-out',
        inDuration: 1500,
        outDuration: 800,
        linkElement: '.animsition-link',
        loading: true,
        loadingParentElement: 'html',
        loadingClass: 'animsition-loading-1',
        loadingInner: '<div data-loader="ball-scale"></div>',
        timeout: false,
        timeoutCountdown: 5000,
        onLoadEvent: true,
        browser: [ 'animation-duration', '-webkit-animation-duration'],
        overlay : false,
        overlayClass : 'animsition-overlay-slide',
        overlayParentElement : 'html',
        transition: function(url){ window.location.href = url; }
    });
    
    /*[ Back to top ]
    ===========================================================*/
    var windowH = $(window).height()/2;

    $(window).on('scroll',function(){
        if ($(this).scrollTop() > windowH) {
            $("#myBtn").css('display','flex');
        } else {
            $("#myBtn").css('display','none');
        }
    });

    $('#myBtn').on("click", function(){
        $('html, body').animate({scrollTop: 0}, 300);
    });


    /*[ Show header dropdown ]
    ===========================================================*/
    $('.js-show-header-dropdown').on('click', function(){
        $(this).parent().find('.header-dropdown')
    });

    var menu = $('.js-show-header-dropdown');
    var sub_menu_is_showed = -1;

    for(var i=0; i<menu.length; i++){
        $(menu[i]).on('click', function(){ 
            
                if(jQuery.inArray( this, menu ) == sub_menu_is_showed){
                    $(this).parent().find('.header-dropdown').toggleClass('show-header-dropdown');
                    sub_menu_is_showed = -1;
                }
                else {
                    for (var i = 0; i < menu.length; i++) {
                        $(menu[i]).parent().find('.header-dropdown').removeClass("show-header-dropdown");
                    }

                    $(this).parent().find('.header-dropdown').toggleClass('show-header-dropdown');
                    sub_menu_is_showed = jQuery.inArray( this, menu );
                }
        });
    }

    $(".js-show-header-dropdown, .header-dropdown").click(function(event){
        event.stopPropagation();
    });

    $(window).on("click", function(){
        for (var i = 0; i < menu.length; i++) {
            $(menu[i]).parent().find('.header-dropdown').removeClass("show-header-dropdown");
        }
        sub_menu_is_showed = -1;
    });


     /*[ Fixed Header ]
    ===========================================================*/
//     var posWrapHeader = $('.topbar').height();
//     var header = $('.container-menu-header');

//     $(window).on('scroll',function(){

//         if($(this).scrollTop() >= posWrapHeader) {
//             $('.header1').addClass('fixed-header');
//             $(header).css('top',-posWrapHeader); 

//         }  
//         else {
//             var x = - $(this).scrollTop(); 
//             $(header).css('top',x); 
//             $('.header1').removeClass('fixed-header');
//         } 

//         if($(this).scrollTop() >= 200 && $(window).width() > 992) {
//             $('.fixed-header2').addClass('show-fixed-header2');
//             $('.header2').css('visibility','hidden'); 
//             $('.header2').find('.header-dropdown').removeClass("show-header-dropdown");
            
//         }  
//         else {
//             $('.fixed-header2').removeClass('show-fixed-header2');
//             $('.header2').css('visibility','visible'); 
//             $('.fixed-header2').find('.header-dropdown').removeClass("show-header-dropdown");
//         } 

//     });
  
//   $('body').css('padding-top', $('header').outerHeight() + 'px')
  //$('.contentforlayout').css('padding-top', $('.topbar-cell').height());
 
 
  if ($('.smart-scroll').length > 0) {
    
    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarVariable = 'smart-scroll';
    if ($(window).width() <= 768) {
      navbarVariable = 'smart-scroll-mobile';
    }
    var navbarHeight = $('.'+navbarVariable).outerHeight();
    var eventtt = '';
    
    $(window).scroll(function(event){
        didScroll = true;
      	eventtt = $(this);
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
      var st = eventtt.scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
		
      	// If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down
//             $('.'+navbarVariable).removeClass('scrolled-down').addClass('scrolled-up');
        } else {
            // Scroll Up
            if(st + $(window).height() < $(document).height()) {
//                 $('.'+navbarVariable).removeClass('scrolled-up').addClass('scrolled-down');
            }
        }

        lastScrollTop = st;
    }
    /*var last_scroll_top = 0;
    var scroll_top;
    $(window).on('scroll', function() {
        var top = $('html').offset().top;
      scroll_top = $(this).scrollTop();
      if(scroll_top < last_scroll_top) {
        $('.smart-scroll').removeClass('scrolled-down').addClass('scrolled-up');
        $('.contentforlayout').css('padding-top', $('.topbar-cell').height());
        console.log(top);
        if(top == 0) {
          $('.smart-scroll').removeClass('scrolled-down').addClass('scrolled-up');
        }
      }
      else {
        $('.smart-scroll').removeClass('scrolled-up').addClass('scrolled-down');
        $('.contentforlayout').css('padding-top', 0);
      }
      last_scroll_top = scroll_top;
    });*/
  }
  
  
    
    /*[ Show menu mobile ]
    ===========================================================*/
//     $('.btn-show-menu-mobile').on('click', function(){
//         $(this).toggleClass('is-active');
//         $('.wrap-side-menu').slideToggle();
//     });

//     var arrowMainMenu = $('.arrow-main-menu');

//     for(var i=0; i<arrowMainMenu.length; i++){
//         $(arrowMainMenu[i]).on('click', function(){
//             $(this).parent().find('.sub-menu').slideToggle();
//             $(this).toggleClass('turn-arrow');
//         })
//     }
  $('.btn-show-menu-mobile').on('click', function(){
    $(this).toggleClass('is-active');
    $('.wrap-side-menu').slideToggle();
    });
    function checkPosition() {
        if (window.matchMedia('(max-width: 480px)').matches) {
            var arrowMainMenu = $('.arrow-main-menu, li.item-menu-mobile>a');
        } else {
            var arrowMainMenu = $('.arrow-main-menu');
        }
    }
    var arrowMainMenu = $('.arrow-main-menu, .item-menu-mobile a');
  	var arrowSubMenu = $('.arrow-sub-menu');
    var arrowSubMenuNo = $('a.item-menu-mobile.noclick');
    for(var i=0; i<arrowMainMenu.length; i++){
        $(arrowMainMenu[i] ).on('click', function(){
            $(this).parent().find('.sub-menu').slideToggle();
            $(this).toggleClass('turn-arrow');
            $(this).siblings('i.arrow-main-menu').toggleClass('turn-arrow');
        })
    }
    for(var i=0; i<arrowSubMenu.length; i++){
      $(arrowSubMenu[i] ).on('click', function(){
        $(this).parent().find('.child-list').slideToggle();
        $(this).toggleClass('turn-arrow');
        $(this).parent().find('.child-list i').toggleClass('turn-arrow');
      })
    }
  	for(var i=0; i<arrowSubMenuNo.length; i++){
        $(arrowSubMenuNo[i] ).on('click', function(e){
          e.preventDefault();
          $(this).parent().find('.child-list').slideToggle();
          $(this).parent().find('.arrow-sub-menu').toggleClass('turn-arrow');
          $(this).parent().find('.child-list i').toggleClass('turn-arrow');
        })
      }
    $(window).resize(function(){
        if($(window).width() >= 992){
            if($('.wrap-side-menu').css('display') == 'block'){
                $('.wrap-side-menu').css('display','none');
                $('.btn-show-menu-mobile').toggleClass('is-active');
            }
            if($('.sub-menu, .sub-menu .child-list').css('display') == 'block'){
                $('.sub-menu, .sub-menu .child-list').css('display','none');
                $('.arrow-main-menu, .arrow-sub-menu').removeClass('turn-arrow');
            }
        }
    });
  
    $('.site-nav__link').mouseover(function() {
      var rel = $(this).data('dropdown-rel');
      var _this1 = $(this);
      $('.mega-menu').each(function (){
        var menu = $(this).data('dropdown');
        if(rel == menu) {
          $(this).addClass('active_menu');
        } else {
          $(this).removeClass('active_menu');
        }
      });
    });

    $(window).hover(function(event){
      $('.site-nav__link').each(function(){
        var rel = $(this).data('dropdown-rel');
        var _this2 = $(this);
        $('.mega-menu').each(function (){
          var menu = $(this).data('dropdown');
          if(rel == menu) {
            if (!$(event.target).closest(".site-nav__link, .dropdown_container").length) {
              $(this).removeClass('active_menu');
            }   
          }
        });
      }); 
    });


    /*[ remove top noti ]
    ===========================================================*/
    $('.btn-romove-top-noti').on('click', function(){
        $(this).parent().remove();
    })


    /*[ Block2 button wishlist ]
    ===========================================================*/
    $('.block2-btn-addwishlist').on('click', function(e){
        e.preventDefault();
        $(this).addClass('block2-btn-towishlist');
        $(this).removeClass('block2-btn-addwishlist');
        $(this).off('click');
    });

    /*[ +/- num product ]
    ===========================================================*/
    $('.btn-num-product-down').on('click', function(e){
        e.preventDefault();
        var numProduct = Number($(this).next().val());
        if(numProduct > 1) $(this).next().val(numProduct - 1);
    });

    $('.btn-num-product-up').on('click', function(e){
        e.preventDefault();
        var numProduct = Number($(this).prev().val());
        $(this).prev().val(numProduct + 1);
    });


    /*[ Show content Product detail ]
    ===========================================================*/
    $('.active-dropdown-content .js-toggle-dropdown-content').toggleClass('show-dropdown-content');
    $('.active-dropdown-content .dropdown-content').slideToggle('fast');

    $('.js-toggle-dropdown-content').on('click', function(){
        $(this).toggleClass('show-dropdown-content');
        $(this).parent().find('.dropdown-content').slideToggle('fast');
    });


    /*[ Play video 01]
    ===========================================================*/
    var srcOld = $('.video-mo-01').children('iframe').attr('src');

    $('[data-target="#modal-video-01"]').on('click',function(){
        $('.video-mo-01').children('iframe')[0].src += "&autoplay=1";

        setTimeout(function(){
            $('.video-mo-01').css('opacity','1');
        },300);      
    });

    $('[data-dismiss="modal"]').on('click',function(){
        $('.video-mo-01').children('iframe')[0].src = srcOld;
        $('.video-mo-01').css('opacity','0');
    });

  /*[ Product page scroll to review section]
    ===========================================================*/
    $('[data-review-link]').on('click', function(event){
      event.preventDefault();
      $('html, body').animate({
        scrollTop: $("#shopify-section-1568883987175").offset().top - 150
      }, 2000);
    })

})(jQuery);

function buildArticleHTML(url, title, image) {
  return `<div class="article-blog-col">
      <div class="article-blog-inner">
          <div class="item-article-blog">
            <figure class="article-blog-thumbnail">
              <a href="${url}" class="article-blog-img">
                <img alt="50 Celebrities with Bunions 2023" src="${image}">        
              </a>
            </figure>
            <div class="article-blog-item-content">
              <h4 class="article-title">
                <a href="${url}" class="">
                  ${title}
                </a>
                </h4>             
            </div>
          </div>
        </div>
      </div>`;
}

var loadMoreButtons = document.querySelectorAll('.js-load-more');

loadMoreButtons.forEach(function(button) {
     window.addEventListener('load', function() {
      button.click();
    });  
    button.addEventListener('click', function()  {
    var $this = this;
    var parentElement = $this.closest('.blogs-articles-container');
    var totalPages = parseInt(parentElement.querySelector('[data-all-pages]').value);
    var currentPage = parseInt(parentElement.querySelector('[data-this-page]').value);
    var datacollurl = parentElement.querySelector('[data-coll-url]').value;
    $this.innerText = 'Loading...';
    var nextUrl = parentElement.querySelector('[data-next-link]').value;
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
      console.log(currentPage,"currentPage")
    fetch(nextUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html'
      }
    })
    .then(function(response) {
      return response.text();
    })
    .then(function(responseHTML) {
      parentElement.querySelector('[data-next-link]').value = datacollurl + "?page=" + next_coll;
      parentElement.querySelector('[data-this-page]').value = current_page_new;
      var wrapper = parentElement.querySelector('.blog-article-wrapper');
      console.log(wrapper,"wrapper")
      var tempElement = document.createElement('div');
      tempElement.innerHTML = responseHTML;
      if(tempElement.querySelector('.pagination')){
        if(tempElement.querySelector('.pagination #next-url')) {
          tempElement.querySelector('.pagination').remove();        
        } else {
           $this.remove();
          tempElement.querySelector('.pagination').remove();
        }
      } else {
        $this.remove();
      }

      if (currentPage == 0 && !tempElement.querySelector('.blog-sec')) {
        parentElement.remove();
      }
      var newContent = tempElement.querySelector('.blog-sec')?.innerHTML;
      var parser = new DOMParser();
      var doc = parser.parseFromString(newContent, 'text/html');
      var articles = doc.querySelectorAll('.blog-col');
      console.log(articles,"dddddddd")
      var content = ''
      articles.forEach(function(article){
        var title = article.querySelector('.blog-title a').innerText.trim();
        var image = article.querySelector('.blog-thumbnail img').src;
        var url = article.querySelector('.blog-title a').href;
        var markup = buildArticleHTML(url, title, image)
        content = content + markup
      });
      
      wrapper.insertAdjacentHTML('beforeend', content);
      $this.innerText = 'Load More...';
      
    })
    .finally(function() {
      if (current_page_new < totalPages) {
        $this.disabled = false;
      }
      if (current_page_new >= totalPages) {
       $this.remove();
      }
    });
  });
})